"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRegisterDeviceAckDto = instanceOfRegisterDeviceAckDto;
exports.RegisterDeviceAckDtoFromJSON = RegisterDeviceAckDtoFromJSON;
exports.RegisterDeviceAckDtoFromJSONTyped = RegisterDeviceAckDtoFromJSONTyped;
exports.RegisterDeviceAckDtoToJSON = RegisterDeviceAckDtoToJSON;
exports.RegisterDeviceAckDtoToJSONTyped = RegisterDeviceAckDtoToJSONTyped;
/**
 * Check if a given object implements the RegisterDeviceAckDto interface.
 */
function instanceOfRegisterDeviceAckDto(value) {
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function RegisterDeviceAckDtoFromJSON(json) {
    return RegisterDeviceAckDtoFromJSONTyped(json, false);
}
function RegisterDeviceAckDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'message': json['message'],
    };
}
function RegisterDeviceAckDtoToJSON(json) {
    return RegisterDeviceAckDtoToJSONTyped(json, false);
}
function RegisterDeviceAckDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'message': value['message'],
    };
}
